export const productConfig = {
  id: 'younesis',
  landingUrl: 'https://younesis.com',
  paymentFailUrl: 'https://younesis.com/fail',
  pwa: {
    name: 'Younesis',
    shortName: 'Younesis',
    description: 'Younesis',
    themeColor: '#171717',
    backgroundColor: '#171717',
    icons: [
      {
        src: '/products/younesis/icons/android-chrome-192x192.png',
        sizes: '192x192',
        type: 'image/png',
      },
      {
        src: '/products/younesis/icons/android-chrome-512x512.png',
        sizes: '512x512',
        type: 'image/png',
      },
      {
        src: '/products/younesis/icons/apple-touch-icon.png',
        sizes: '180x180',
        type: 'image/png',
      },
    ],
  },
}
